import moment from 'moment';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/produitConf';
import { ETAT_ENCOURS, ETAT_ENREGISTRE, NORMAL } from '@/configuration/devisConf';
import genererGuid from '@/services/general/genererGuid';
import formatDate from '@/services/general/formatIsoDate';
import genererEcheancierAuto from '@/services/devisCommandes/echeanciers/genererEcheancierAuto';

function getEcheancierAndReferenceEcheancier(ligne, devis) {
  if (ligne.type === NORMAL) {
    const echeancier = genererEcheancierAuto(
      [ligne], devis.datePremierAffichage, devis.dateDevisCommande,
    );
    devis.echeanciers.push(echeancier);
    ligne.referenceEcheancier = echeancier.referenceEcheancier;
  }
}

function addReferenceEcheancierToLigneCommande(ligne, devis) {
  getEcheancierAndReferenceEcheancier(ligne, devis);
  if (!ligne.lignesCommande) return;
  ligne.lignesCommande.forEach((ligneEnfant) => {
    ligneEnfant.dateDebut = ligne.dateDebut;
    ligneEnfant.dateFin = ligne.dateFin;
    ligneEnfant.ligneReseau = ligne.ligneReseau;
    getEcheancierAndReferenceEcheancier(ligneEnfant, devis);
  });
}

function updateAllDateInCmd(cmd, oldDate) {
  const days = moment(cmd.datePremierAffichage).diff(moment(oldDate), 'days');
  cmd.dateDevisCommande = new Date();
  cmd.dateValidite = formatDate(cmd.dateValidite);
  cmd.dateValidite = cmd.dateValidite ? new Date(moment(cmd.dateValidite).add(days, 'd').toDate()) : null;
  cmd.lignesCommande.forEach((ligne) => {
    ligne.dateDebut = ligne.dateDebut ? new Date(moment(ligne.dateDebut).add(days, 'd').toDate()) : null;
    ligne.dateFin = ligne.dateFin ? new Date(moment(ligne.dateFin).add(days, 'd').toDate()) : null;
  });
  cmd.echeanciers.forEach((echeancier) => {
    echeancier.dateDebut = echeancier.dateDebut ? new Date(moment(echeancier.dateDebut).add(days, 'd').toDate()) : null;
    echeancier.dateFin = echeancier.dateFin ? new Date(moment(echeancier.dateFin).add(days, 'd').toDate()) : null;
    echeancier.dateFinPremiereEcheance = echeancier.dateFinPremiereEcheance
      ? new Date(moment(echeancier.dateFinPremiereEcheance).add(days, 'd').toDate()) : null;
    echeancier.echeancierLignes.forEach(ligne => {
      ligne.dateDebut = ligne.dateDebut ? new Date(moment(ligne.dateDebut).add(days, 'd').toDate()) : null;
      ligne.dateFin = ligne.dateFin ? new Date(moment(ligne.dateFin).add(days, 'd').toDate()) : null;
      ligne.datePrevisionnelleFacturation = ligne.datePrevisionnelleFacturation
        ? new Date(moment(ligne.datePrevisionnelleFacturation).add(days, 'd').toDate()) : null;
    });
  });
}

export default function genererCopyDevisCommande(devisCommande, newDateCmd) {
  const copy = cloneDeep(devisCommande);
  copy.acomptesAffectes = [];
  copy.code = null;
  copy.datePremierAffichage = new Date(newDateCmd);
  if (copy.datePremierAffichage) copy.datePremierAffichage = new Date(copy.datePremierAffichage);
  copy.creationTime = null;
  copy.etat = ETAT_ENREGISTRE;
  copy.etatRenouvellement = ETAT_ENCOURS;
  copy.devisCommandeInitialeId = null;
  copy.id = null;
  copy.estSigne = false;
  copy.intervenants.forEach(inter => {
    inter.id = null;
    inter.guid = genererGuid();
    inter.nomCommercial = get(inter, 'tiers.nomCommercial', inter.nomCommercial);
    inter.adressePostale = get(inter, 'tiers.adressePostale', inter.adressePostale);
  });
  copy.lignesCommande.forEach(ligne => {
    delete ligne.isAffecteLogistiquement;
    ligne.commandeId = null;
    ligne.id = null;
    ligne.idLigneHavas = null;
    ligne.devCodeHavas = null;
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
      ligne.etatDeLaDemande = true;
      ligne.etatProvisoire = AUCUN;
      ligne.etatObtenu = AUCUN;
      ligne.messagesAvertissement = null;
      ligne.rangOption = null;
    }
    ligne.lignesCommande.forEach(el => {
      delete el.isAffecteLogistiquement;
      el.id = null;
      el.idLigneHavas = null;
      el.devCodeHavas = null;
      el.etatDeLaDemande = false;
    });
    ligne.lignesRemise.forEach(el => {
      el.id = null;
    });
    ligne.lignesCmdSelOptionProduit = [];
  });
  copy.planMediaId = null;
  copy.referenceId = null;
  copy.msgAvertissementVentePartielle = [];
  copy.repartitionsTva.forEach(rep => {
    rep.id = null;
  });
  if (!copy.echeanciers || copy.echeanciers.length === 0) {
    copy.gestionEcheancier = false;
    copy.lignesCommande.forEach((ligne) => {
      if (ligne.type === NORMAL) addReferenceEcheancierToLigneCommande(ligne, copy);
      if (ligne.lignesCommande) {
        ligne.lignesCommande.forEach((ligneEnfant) => {
          if (ligneEnfant.type === NORMAL) addReferenceEcheancierToLigneCommande(ligneEnfant, copy);
        });
      }
    });
    updateAllDateInCmd(copy, devisCommande.datePremierAffichage);
    return copy;
  }
  copy.gestionEcheancier = true;
  copy.echeanciers.forEach(echeancier => {
    echeancier.facturationFaite = false;
    echeancier.openEcheancierLignes = !!echeancier.quantitePeriodicite;
    echeancier.echeancierLignes.forEach(ligne => {
      ligne.id = genererGuid();
      ligne.fromGeneration = true;
      ligne.factureId = null;
      ligne.facturationFaite = false;
    });
    echeancier.id = genererGuid();
  });
  updateAllDateInCmd(copy, devisCommande.datePremierAffichage);
  return copy;
}
